
// ================== ADD ==================== //
import { AddCostumer } from './insert/AddCliente'; 
import { AddPartner } from './insert/AddPartner'; 
import { AddBug } from './insert/AddBug.js'; 




// ================== ALTER ==================== //
import { AlterCliente } from './alter/AlterCliente.js'; 
import { AlterLicenca } from './alter/AlterLicenca.js'; 
import { AlterUser } from './alter/AlterUser.js'; 
import { AtiveUser } from './alter/AtiveUser.js'; 
import { AlterBug } from './alter/AlterBug.js'; 
import { AlterBugStatus } from './alter/AlterBugStatus.js'; 
import { DesativarUser } from './alter/DesativarUser.js'; 



// ================== DELETE ==================== //
import { DeleteCliente } from './delete/DeleteCliente.js';
import { DeleteUser } from './delete/DeleteUser.js';
import { DeleteBug } from './delete/DeleteBug.js';



// ================== LIST ==================== //
import { ListUser } from './list/ListUser.js';
import { ListCostumers } from './list/ListCostumers.js';
import { ListLicenca } from './list/ListLicenca.js';
import { ListSenha } from './list/ListSenha.js';
import { ListPagamento } from './list/ListPagamento.js';
import { ListBug } from './list/ListBug.js';


// ================== LOGIN/LOGOUT ==================== //
import { Login } from './Login.js';
import { Logout } from './Logout.js';




const Api = {
  AddCostumer,
    ListUser,
    ListCostumers,
    AlterCliente,
    DeleteCliente,
    ListLicenca,
    ListSenha,
    ListPagamento,
    AlterLicenca,
    Login,
    Logout,
    DeleteUser,
    AlterUser,
    AtiveUser,
    AddPartner,
    ListBug,
    AddBug,
    AlterBug,
    DeleteBug,
    AlterBugStatus,
    DesativarUser
  };


export default Api;